import "./newsletter.scss";

import React, { useState } from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { navigate, Link } from "gatsby";

const url =
  "https://elcamp.us5.list-manage.com/subscribe/post?u=928aaaef025ba15606928b915&amp;id=0010776cff";
const NewsletterForm = ({ status, message, onValidated }) => {
  const [legal, setLegal] = useState(false);
  let email;
  const submit = (e) =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
    });
  status === "success" && navigate("/dziekujemy-za-zapisanie");
  return (
    <>
      <div className="newsletter__form">
        <input
          type="email"
          name="email"
          id="email"
          placeholder="podaj swoj adres email"
          className="newsletter__input"
          ref={(node) => (email = node)}
        />
        <button
          onClick={submit}
          type="submit"
          className="newsletter__button"
          disabled={!legal && "disabled"}
        >
          Subskrybuj!
        </button>
      </div>
      <label
        className="checkbox-wrapper-newsletter checkbox-wrapper--newsletter"
        htmlFor="acceptanceNewsletter"
      >
        <input
          type="checkbox"
          name="acceptanceNewsletter"
          id="acceptanceNewsletter"
          onChange={(e) => setLegal(!legal)}
        />
        <span>
          Wyrażam dobrowolną zgodę na przetwarzanie moich danych osobowych przez
          Elcamp RV sp. z.o.o. z siedzibą w Krakowie, ul. Tyniecka 118E, 30-376
          Kraków, KRS: 0000965816 (Administrator danych), w celu marketingu
          bezpośredniego dotyczącego własnych produktów i usług. Obowiązek
          informacyjny zgodnie z art. 13 ogólnego rozporządzenia o ochronie
          danych osobowych (RODO) z dnia 27 kwietnia 2016 r. (Dz. Urz. UE L 119
          z 04.05.2016): informacje o przetwarzaniu przez nas danych, jak
          również o prawach osób, których dane dotyczą znajdują się w naszej{" "}
          <Link to="/ogolne-warunki-sprzedazy-i-gwarancji#polityka-prywatnosci">
            Polityce Prywatności
          </Link>
          *
        </span>
      </label>
      <div className="newsletter__message">
        {status === "sending" && (
          <div className="newsletter__message--normal">zapisywanie...</div>
        )}
        {status === "error" && (
          <div
            className="newsletter__message--warning"
            dangerouslySetInnerHTML={{
              __html:
                "Coś poszło nie tak. Możliwe, że ten adres jest już w naszej bazie. Spróbuj ponownie później",
            }}
          />
        )}
        {status === "success" && <div className="newsletter__message--ok" />}
      </div>
    </>
  );
};

const Newsletter = () => {
  return (
    <section className="newsletter">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h2 className="newsletter__title">
            Zapisz się do naszego newslettera!
          </h2>
          <div className="newsletter__desc">
            Bądź na bieżąco z nowościami i ofertami specjalnymi.
          </div>
          <MailchimpSubscribe
            url={url}
            render={({ subscribe, status, message }) => (
              <NewsletterForm
                status={status}
                message={message}
                onValidated={(formData) => subscribe(formData)}
              />
            )}
          />
          {/* <form className="newsletter__form">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="podaj swoj adres email"
              className="newsletter__input"
            />
            <button type="submit" className="newsletter__button">
              Subskrybuj!
            </button>
          </form> */}
          {/* <Mailchimp
            action="https://elcamp.us5.list-manage.com/subscribe/post?u=928aaaef025ba15606928b915&amp;id=0010776cff"
            fields={[
              {
                name: "EMAIL",
                placeholder: "Email",
                type: "email",
                required: true,
                className: "xdxdxd",
              },
            ]}
            messages={{
              sending: "Trwa zapisywanie...",
              success: "ok",
              error: "Wystąpił błąd. Spróbuj ponownie później",
              empty: "E-mail jest wymagany",
              duplicate: "Twój e-mail jest już w naszej bazie",
              button: "Subskrybuj!",
            }}
            className="newsletter__form"
          /> */}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
